/* No Rivals-style on-card buy box. Event-delegated; survives AJAX grid updates. */
(function () {
  'use strict';
  if (window.__nrBBInit) return;
  window.__nrBBInit = true;

  var COLORS = {
    'black': '#111111', 'white': '#ffffff', 'cream': '#f5f0e1', 'ivory': '#f7f3e8',
    'navy': '#1b2a4a', 'royal blue': '#2b4bd1', 'light blue': '#b1c5d4', 'blue': '#2b4bd1',
    'maroon': '#7b1e2b', 'light maroon': '#a0344a', 'garnet': '#7a0d1a', 'red': '#c0392b',
    'purple': '#5b2a86', 'light purple': '#c6aec7', 'green': '#3f7d4f', 'dark green': '#0c3b22',
    'teal': '#0d8a8a', 'brown': '#5c4033', 'charcoal': '#36454f', 'orange': '#e8771f',
    'gold': '#c9a227', 'pink': '#e89bb0', 'heather grey': '#9aa0a6', 'grey': '#8b9096',
    'gray': '#8b9096', 'light grey': '#c8ccd0', 'light gray': '#c8ccd0'
  };
  function hexFor(name) {
    if (!name) return null;
    var n = String(name).toLowerCase();
    // try longest keys first for "light blue" before "blue"
    var keys = Object.keys(COLORS).sort(function (a, b) { return b.length - a.length; });
    for (var i = 0; i < keys.length; i++) { if (n.indexOf(keys[i]) !== -1) return COLORS[keys[i]]; }
    return null;
  }
  function money(cents) {
    try {
      return '$' + (cents / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    } catch (e) { return '$' + (cents / 100).toFixed(2); }
  }

  // Parse + cache the card state
  function state(bb) {
    if (bb.__nr) return bb.__nr;
    var json = bb.querySelector('[data-nr-variants]');
    var variants = [];
    try { variants = JSON.parse(json.textContent); } catch (e) {}
    var s = {
      variants: variants,
      sizePos: parseInt(bb.getAttribute('data-size-pos'), 10) || 0,
      colorPos: parseInt(bb.getAttribute('data-color-pos'), 10) || 0,
      threshold: parseInt(bb.getAttribute('data-threshold'), 10) || 10,
      url: bb.getAttribute('data-url'),
      color: null, size: null
    };
    bb.__nr = s;
    return s;
  }
  function optVal(v, pos) { return pos === 1 ? v.o1 : pos === 2 ? v.o2 : pos === 3 ? v.o3 : null; }

  function findVariant(s) {
    return s.variants.filter(function (v) {
      if (s.colorPos && optVal(v, s.colorPos) !== s.color) return false;
      if (s.sizePos && optVal(v, s.sizePos) !== s.size) return false;
      return true;
    })[0] || null;
  }
  // is a given size available for the currently selected color?
  function sizeAvailable(s, size) {
    return s.variants.some(function (v) {
      if (optVal(v, s.sizePos) !== size) return false;
      if (s.colorPos && s.color && optVal(v, s.colorPos) !== s.color) return false;
      return v.avail;
    });
  }
  function variantForSize(s, size) {
    return s.variants.filter(function (v) {
      if (optVal(v, s.sizePos) !== size) return false;
      if (s.colorPos && s.color && optVal(v, s.colorPos) !== s.color) return false;
      return true;
    })[0] || null;
  }

  function paintColors(bb, s) {
    bb.querySelectorAll('[data-nr-colors] .nr-bb__color').forEach(function (btn) {
      var name = btn.getAttribute('data-color');
      var hex = hexFor(name);
      var sw = btn.querySelector('.nr-bb__sw');
      if (hex) { sw.style.setProperty('--nr-sw', hex); }
      else { btn.classList.add('nr-bb__color--named'); sw.textContent = name; }
      btn.classList.toggle('is-active', name === s.color);
    });
  }
  function paintSizes(bb, s) {
    bb.querySelectorAll('[data-nr-sizes] .nr-bb__size').forEach(function (btn) {
      var size = btn.getAttribute('data-size');
      var oos = !sizeAvailable(s, size);
      btn.classList.toggle('nr-bb__size--oos', oos);
      btn.classList.toggle('is-active', size === s.size);
    });
  }
  function setStock(bb, s, variant) {
    var el = bb.querySelector('[data-nr-stock]');
    if (variant && variant.track && variant.inv > 0 && variant.inv <= s.threshold) {
      el.textContent = 'Only ' + variant.inv + ' left in stock!';
      el.hidden = false;
    } else { el.hidden = true; el.textContent = ''; }
  }
  function setAtc(bb, s) {
    var btn = bb.querySelector('[data-nr-atc]');
    var label = btn.querySelector('[data-nr-atc-label]');
    var sub = btn.querySelector('[data-nr-atc-sub]');
    btn.classList.remove('nr-bb__atc--notify', 'is-added');
    var needSize = s.sizePos > 0 && !s.size;
    var needColor = s.colorPos > 0 && !s.color;
    if (needSize || needColor) {
      label.textContent = needSize ? 'Select Size' : 'Select Color';
      sub.textContent = ''; btn.disabled = true; setStock(bb, s, null); return;
    }
    var v = findVariant(s);
    if (v && v.avail) {
      label.textContent = 'Add to Cart'; sub.textContent = '· ' + money(v.price);
      btn.disabled = false; btn.dataset.variant = v.id; setStock(bb, s, v);
    } else {
      label.textContent = 'Notify me when back in stock'; sub.textContent = '';
      btn.disabled = false; btn.classList.add('nr-bb__atc--notify');
      btn.dataset.variant = v ? v.id : ''; setStock(bb, s, null);
    }
  }

  function init(bb) {
    var s = state(bb);
    if (s.colorPos) {
      // default to first color that has any available variant, else first
      var colors = Array.prototype.map.call(bb.querySelectorAll('[data-nr-colors] .nr-bb__color'), function (b) { return b.getAttribute('data-color'); });
      var firstAvail = colors.filter(function (c) { return s.variants.some(function (v) { return optVal(v, s.colorPos) === c && v.avail; }); })[0];
      s.color = firstAvail || colors[0] || null;
      paintColors(bb, s);
    }
    if (s.sizePos) paintSizes(bb, s);
    setAtc(bb, s);
    bb.setAttribute('data-nr-ready', '1');
  }
  function ensure(bb) { if (!bb.getAttribute('data-nr-ready')) init(bb); return state(bb); }

  function goNotify(s, variantId) {
    var url = s.url + (s.url.indexOf('?') === -1 ? '?' : '&') + 'variant=' + variantId + '&notify=1';
    var pv = (window.location.search.match(/[?&]preview_theme_id=(\d+)/) || [])[1];
    if (pv) url += '&preview_theme_id=' + pv;
    window.location.href = url; // PDP auto-opens the AMP Back in Stock form (via ?notify=1)
  }

  // On a product page reached via a sold-out size click, auto-open the AMP "Back in Stock" form.
  function autoOpenRestock() {
    if (!/[?&]notify=1/.test(window.location.search)) return;
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      var btn = document.querySelector('.bis-inline-target .BIS_trigger, .bis-button.BIS_trigger, a.BIS_trigger, button.BIS_trigger, .BIS_trigger');
      if (btn) { clearInterval(iv); try { btn.click(); } catch (e) {} }
      else if (tries > 25) { clearInterval(iv); }
    }, 300);
  }

  // On a PRODUCT page, show a visible "Notify me when back in stock" button above the
  // (sold-out) add-to-cart, wired to AMP's hidden Back-in-Stock trigger.
  function initPDP() {
    if (document.querySelector('[data-nr-bb]')) { /* still also run on PDP if cards exist */ }
    var amp = document.querySelector('.BIS_trigger');
    var atc = document.querySelector('product-form button[name="add"], .m-product-form button[name="add"], form[action*="/cart/add"] button[name="add"], .m-product-form .m-add-to-cart, .m-add-to-cart');
    if (!amp || !atc) return;
    if (document.querySelector('.nr-pdp-notify')) return;
    // hide AMP's own (poorly-placed) button; we trigger it programmatically instead
    if (!document.getElementById('nr-bis-hide')) {
      var st = document.createElement('style'); st.id = 'nr-bis-hide';
      st.textContent = '.bis-relocated,.bis-button.BIS_trigger,.bis-inline-target,[class*="bis-inline"]{position:absolute!important;left:-9999px!important;width:1px!important;height:1px!important;overflow:hidden!important;}';
      document.head.appendChild(st);
    }
    var nb = document.createElement('button');
    nb.type = 'button';
    nb.className = 'nr-pdp-notify';
    nb.style.cssText = 'width:100%;padding:14px;cursor:pointer;border:0;border-radius:8px;background:#f59e0b;color:#1e1e1e;font-weight:700;font-size:15px;line-height:1.1;margin-bottom:12px;display:block;';
    nb.textContent = 'Notify me when back in stock';
    nb.addEventListener('click', function (e) { e.preventDefault(); try { amp.click(); } catch (err) {} });
    var host = atc.closest('.m-product-form__buttons') || atc.closest('product-form') || atc.closest('.m-product-form') || atc.parentElement;
    host.parentElement.insertBefore(nb, host);
    function sync() {
      var soldout = /sold\s*out/i.test(atc.textContent) || atc.disabled || atc.classList.contains('m-add-to-cart--sold-out');
      nb.style.display = soldout ? 'block' : 'none';
    }
    sync();
    try { new MutationObserver(sync).observe(atc, { childList: true, subtree: true, characterData: true, attributes: true }); } catch (e) {}
  }

  function addToCart(bb, s, variantId) {
    var btn = bb.querySelector('[data-nr-atc]');
    var label = btn.querySelector('[data-nr-atc-label]');
    var prev = label.textContent;
    btn.disabled = true; label.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    }).then(function (r) { return r.json(); }).then(function () {
      btn.classList.add('is-added'); label.textContent = 'Added ✓';
      updateCartCount();
      // Native Minimog flow: re-render the cart drawer AND open it in one atomic op (no overlay-stuck race).
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
      setTimeout(function () { btn.classList.remove('is-added'); btn.disabled = false; setAtc(bb, s); }, 1600);
    }).catch(function () { btn.disabled = false; label.textContent = prev; });
  }
  // Update only the header cart count; the cart:refresh dispatch (detail.open:true) re-renders + opens the drawer natively.
  function updateCartCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.m-cart-count, [data-cart-count], .m-cart-icon-bubble [data-count]').forEach(function (el) {
          el.textContent = cart.item_count; el.classList.remove('m:hidden', 'hidden');
        });
      }).catch(function () {});
  }

  // ---- delegated events ----
  document.addEventListener('click', function (e) {
    var sizeBtn = e.target.closest('.nr-bb__size');
    if (sizeBtn) {
      e.preventDefault();
      var bb = sizeBtn.closest('[data-nr-bb]'); var s = ensure(bb);
      var size = sizeBtn.getAttribute('data-size');
      // Select the size (in-stock OR sold-out). setAtc() flips the button to
      // "Notify me when back in stock" when the chosen size is sold out.
      s.size = size; paintSizes(bb, s); setAtc(bb, s); return;
    }
    var colorBtn = e.target.closest('.nr-bb__color');
    if (colorBtn) {
      e.preventDefault();
      var bb2 = colorBtn.closest('[data-nr-bb]'); var s2 = ensure(bb2);
      s2.color = colorBtn.getAttribute('data-color'); s2.size = null;
      paintColors(bb2, s2); if (s2.sizePos) paintSizes(bb2, s2); setAtc(bb2, s2); return;
    }
    var atc = e.target.closest('[data-nr-atc]');
    if (atc) {
      e.preventDefault();
      var bb3 = atc.closest('[data-nr-bb]'); var s3 = ensure(bb3);
      var vid = atc.dataset.variant;
      if (!vid) return;
      if (atc.classList.contains('nr-bb__atc--notify')) { goNotify(s3, vid); return; }
      addToCart(bb3, s3, vid);
    }
  }, false);

  // init visible cards on load + when grids change
  function initAll(root) { (root || document).querySelectorAll('[data-nr-bb]:not([data-nr-ready])').forEach(init); }
  // AMP's Back-in-Stock trigger loads async, so poll a few times to inject the PDP button.
  function pdpPoll() { var n = 0; var iv = setInterval(function () { n++; initPDP(); if (document.querySelector('.nr-pdp-notify') || n > 16) clearInterval(iv); }, 400); }
  function boot() { initAll(); autoOpenRestock(); pdpPoll(); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) { if (muts[i].addedNodes && muts[i].addedNodes.length) { initAll(); break; } }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
